import React, { ReactNode, useState } from "react";
import { MdOutlineVisibility, MdOutlineVisibilityOff } from "react-icons/md";
import classNames from "classnames";
import { FormikErrors, FormikTouched, getIn } from "formik";
import { twMerge } from "tailwind-merge";

interface TextFieldProps<T> {
  id: string;
  value: string | number;
  onChange: (e: React.ChangeEvent<unknown>) => void;
  onBlur: (e: React.ChangeEvent<unknown>) => void;
  touched?: FormikTouched<T>;
  errors?: FormikErrors<T>;
  hideable?: boolean;
  placeholder?: string;
  disabled?: boolean;
}

const TextField: React.FC<TextFieldProps<unknown>> = ({
  id,
  value,
  onChange,
  onBlur,
  touched = {},
  errors = {},
  hideable = false,
  disabled = false,
  placeholder,
}) => {
  // hooks
  const [showHiddenText, setHiddenText] = useState<boolean>(!hideable);

  // classes
  const inputContainerClasses = twMerge(
    classNames("w-full text-cDarkBlue relative flex flex-col rounded", {
      "border-b border-red-700": getIn(errors, id) && getIn(touched, id),
      "opacity-50 cursor-not-allowed": disabled,
    })
  );
  const inputClasses = classNames(
    "w-full min-h-12 border border-secondary rounded shadow p-2 text-gray-700 focus:outline-none"
  );
  const errorMessageClasses = classNames("text-sm text-red-700");

  return (
    <div className={inputContainerClasses}>
      <div className="relative">
        <input
          id={id}
          type={showHiddenText ? "text" : "password"}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          className={inputClasses}
          disabled={disabled}
        />

        {hideable &&
          (showHiddenText ? (
            <MdOutlineVisibilityOff
              className="absolute text-xl text-black right-1 bottom-1 text-customBlue"
              onClick={() => {
                setHiddenText(false);
              }}
            />
          ) : (
            <MdOutlineVisibility
              className="absolute text-xl text-black right-1 bottom-1 text-customBlue"
              onClick={() => {
                setHiddenText(true);
              }}
            />
          ))}
      </div>

      {getIn(errors, id) && getIn(touched, id) && (
        <div className={errorMessageClasses}>
          {" "}
          {getIn(errors, id) as ReactNode}{" "}
        </div>
      )}
    </div>
  );
};

export default TextField;
